import reducer, { initialState } from '../../reducers/tokenFlow';
import * as actions from '../../actions/tokenFlow';

const fn = { reducer, initialState, actions };
export default fn;
 